import React from "react";

import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { Formik } from "formik";
import { FaArrowLeft } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import * as Yup from "yup";

import api from "../../../service/api";
import { ButtunSubmit, Container, ContainerForm, Error, Form } from "../styles";

const CreateUser: React.FC = () => {
  const { addToast } = useToasts();
  const history = useHistory();

  async function handleSubmit(create: any) {
    try {
      await api.post("/sector", {
        name: create.name,
        abbreviation: create.abbreviation,
        qtd: create.qtd,
      });

      addToast("Setor criado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push("/setores");
    } catch (error: any) {
      if (!error.response) {
        return addToast(
          "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }

      return addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }

  return (
    <Container>
      <header>
        <button
          type="button"
          onClick={() => {
            history.goBack();
          }}
          className="arrowBack"
        >
          <FaArrowLeft size={18} />
        </button>

        <h2>Criar Setor</h2>
      </header>

      <ContainerForm>
        <Formik
          initialValues={{
            name: undefined,
            abbreviation: undefined,
            qtd: undefined,
          }}
          validationSchema={Yup.object({
            name: Yup.string().required("Nome é obrigatório"),
            abbreviation: Yup.string().required("Abreviação é obrigatório"),
            qtd: Yup.string().required("Abreviação é obrigatório"),
          })}
          onSubmit={(data) => handleSubmit(data)}
        >
          {(formik) => (
            <Form onSubmit={formik.handleSubmit}>
              <div className="field-group">
                <div className="field">
                  <label htmlFor="name">Nome</label>
                  <input {...formik.getFieldProps("name")} />
                  {formik.touched.name && formik.errors.name ? (
                    <Error>
                      <FiAlertCircle color="#f00" size={16} />
                      <span> {formik.errors.name} </span>
                    </Error>
                  ) : null}
                </div>
                <div className="field">
                  <label htmlFor="abbreviation">Abreviação</label>
                  <input {...formik.getFieldProps("abbreviation")} />
                  {formik.touched.abbreviation && formik.errors.abbreviation ? (
                    <Error>
                      <FiAlertCircle color="#f00" size={16} />
                      <span> {formik.errors.abbreviation} </span>
                    </Error>
                  ) : null}
                </div>
                <div className="field">
                  <label htmlFor="qtd">Quantidade</label>
                  <input {...formik.getFieldProps("qtd")} />
                  {formik.touched.qtd && formik.errors.qtd ? (
                    <Error>
                      <FiAlertCircle color="#f00" size={16} />
                      <span> {formik.errors.qtd} </span>
                    </Error>
                  ) : null}
                </div>
              </div>

              <ButtunSubmit type="submit"> Criar </ButtunSubmit>
            </Form>
          )}
        </Formik>
      </ContainerForm>
    </Container>
  );
};

export default CreateUser;
